import { z } from 'zod';

/// //////////////////////////////////////////////////
/// Model
/// /////////////////////////////////////////////////
export const PriorProjectIdModel = z.object({
  priorProjectId: z.string().uuid().nullable(),
});
